import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import paymentPageLoader from './paymentPageLoader'
import getTransaction from '../api/getTransaction'
import { PaymentPageInfo } from '../types/paymentPageInfo'
import { PixTransactionResult } from '../types/TransactionResult'

export interface PixPayPageData {
    paymentPageInfo: PaymentPageInfo
    transaction: PixTransactionResult
}

const pixPayPageLoader = async (args: LoaderFunctionArgs): Promise<PixPayPageData> => {
    const { paymentPageId, transactionId } = args.params

    if (!paymentPageId || !transactionId) {
        throw new Response('Payment page ID and transaction ID are required', { status: 400 })
    }

    const [paymentPageInfo, transaction] = await Promise.all([
        paymentPageLoader({...args, params: { ...args.params, method: 'pix' }}),
        getTransaction(paymentPageId, transactionId),
    ])

    if (transaction.type !== 'init') {
        throw redirect(`/result/${paymentPageInfo.id}/${transaction.transactionId}`)
    }

    return { paymentPageInfo, transaction: transaction as PixTransactionResult }
}

export default pixPayPageLoader
